import { Link } from "react-router-dom";
import { MapPin, Mail, Instagram } from "lucide-react";
import TikTokIcon from "./TikTokIcon";

export default function Footer() {
  return (
    <footer className="border-t border-line bg-surface mt-24" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src="/logo-crest.png" alt="Stemma Artemide FC" className="h-12 w-12 object-contain" />
            <img src="/logo-deer.png" alt="Marchio cervo Artemide FC" className="h-10 w-auto" />
          </div>
          <p className="text-zinc-400 text-sm mt-3">
            Due squadre, un'unica anima nero-gialla: Prima Squadra FIGC e Seconda Squadra CSI.
          </p>
        </div>
        <div>
          <h3 className="font-mono text-xs tracking-[0.25em] uppercase text-gold mb-4">Navigazione</h3>
          <ul className="space-y-2 text-zinc-300">
            <li><Link to="/chi-siamo" data-testid="footer-chi-siamo-link" className="hover:text-gold transition-colors">Chi Siamo</Link></li>
            <li><Link to="/calendario" data-testid="footer-calendario-link" className="hover:text-gold transition-colors">Calendario</Link></li>
            <li><Link to="/classifiche" data-testid="footer-classifiche-link" className="hover:text-gold transition-colors">Classifiche e Live</Link></li>
            <li><Link to="/squadre" data-testid="footer-squadre-link" className="hover:text-gold transition-colors">Squadre</Link></li>
            <li><Link to="/team" data-testid="footer-team-link" className="hover:text-gold transition-colors">Il Nostro Team</Link></li>
            <li><Link to="/partner" data-testid="footer-partner-link" className="hover:text-gold transition-colors">Partner</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="font-mono text-xs tracking-[0.25em] uppercase text-gold mb-4">Contatti</h3>
          <p className="flex items-center gap-2 text-zinc-300 text-sm mb-2">
            <MapPin size={15} className="text-gold" /> Centro Sportivo Calvairate
          </p>
          <p className="flex items-center gap-2 text-zinc-300 text-sm">
            <Mail size={15} className="text-gold" /> artemidefc@gmail.com
          </p>
          <div className="flex items-center gap-4 mt-5">
            <a
              href="https://www.instagram.com/artemidefc"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram-link"
              aria-label="Instagram Artemide FC"
              className="text-zinc-300 hover:text-gold transition-colors"
            >
              <Instagram size={22} />
            </a>
            <a
              href="https://www.tiktok.com/@artemide.fc"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-tiktok-link"
              aria-label="TikTok Artemide FC"
              className="text-zinc-300 hover:text-gold transition-colors"
            >
              <TikTokIcon size={20} />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-line">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-zinc-500 text-xs font-mono tracking-wider">© 2026 ARTEMIDE FOOTBALL CLUB — TUTTI I DIRITTI RISERVATI</p>
          <p className="text-zinc-600 text-xs font-mono tracking-wider">NERO · GIALLO · BIANCO</p>
        </div>
      </div>
    </footer>
  );
}
